import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import { Attribute } from '../../decorators/attribute.decorator';
import styles from './ui-brandingbar.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIBrandingBar
 * @element ui-brandingbar
 * @classdesc Represents a class for <code>ui-brandingbar</code> element.
 * The most top orange bar on the every page. Button bar cannot be animated
 * or used as progress bar by branding rules.
 * @property {boolean} [animated] {@attr animated} Loading animation enabled/disabled
 * when '-loading' class added to <html>.
 * @example <ui-brandingbar></ui-brandingbar>
 */
@Component({
    tag: 'ui-brandingbar',
    styles,
})
export class UIBrandingBar extends UIElement {
    @Attribute(Boolean) animated?: boolean;
}
